import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import ownerAgrementServices from "../../services/owner-services/owner-agreement";
import { handleErrors } from "../../utils/errorHandler";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const OwnerAgreementTable = () => {
  const [agreementList, setAgreementList] = useState([]);

  useEffect(() => {
    async function fetchAgreementData() {
      try {
        const response = await ownerAgrementServices.getAgreementInfo();
        setAgreementList(response.data.result || []);
      } catch (error) {
        toast.error(handleErrors(error));
      }
    }

    fetchAgreementData();
  }, []);
  const propertyNameWithFlatNo = (rowData) => {
    return (
      <div>
        <b> Property Name : </b>
        {rowData.propertyName},
        <br />
        <b> Flat No : </b> {rowData.flatNos}
      </div>
    );
  };
  const renderUnsignedDocButton = (rowData) => {
    if (!rowData.unsignedDocLink) return "-";

    return (
      <button
        onClick={() => window.open(rowData.unsignedDocLink, "_blank")}
        className="badge bg-success fs-8"
      >
        View Unsigned Doc
      </button>
    );
  };
  const renderSignedDocButton = (rowData) => {
    if (!rowData.signedDocLink) return "-";

    return (
      <button
        onClick={() => window.open(rowData.signedDocLink, "_blank")}
        className="badge bg-primary fs-8"
      >
        View Signed Doc
      </button>
    );
  };
  const formatDated = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(dateString)
      .toLocaleDateString("en-GB", options)
      .replace(/ /g, "-");
  };
  const renderStatusBadge = (rowData) => {
    const status = rowData.status?.toLowerCase();

    let badgeColor = "secondary";
    let label = rowData.status || "Unknown";

    if (status === "created") {
      badgeColor = "warning";
    } else if (status === "sent") {
      badgeColor = "info";
    } else if (status === "signed") {
      badgeColor = "success";
    }

    return (
      <span className={`badge bg-${badgeColor} text-uppercase`}>{label}</span>
    );
  };

  return (
    <div className="agreement-list">
      <h3>Agreements Details</h3>
      <Row>
        <Col xs={12}>
          <DataTable
            value={agreementList}
            paginator
            rows={10}
            showGridlines
            stripedRows
          >
            <Column header="#" body={(rowData, { rowIndex }) => rowIndex + 1} />
            <Column field={propertyNameWithFlatNo} header="Property Name" />
            <Column field={renderUnsignedDocButton} header="UnSigned Doc" />
            <Column field={renderSignedDocButton} header="Signed Doc" />
            <Column field={renderStatusBadge} header="Status" />
            <Column
              body={(rowData) => formatDated(rowData.createdOn)}
              header="Created On"
            />
            <Column
              body={(rowData) =>
                rowData.signedDocLink ? formatDated(rowData.signedOn) : "-"
              }
              header="Signed On"
            />
          </DataTable>
        </Col>
      </Row>
    </div>
  );
};

export default OwnerAgreementTable;
